export const UsernameDigits = Object.freeze({
  enabled: 4,
  disabled: 0,
});
